import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from'../Component/Header';  
import Footer from'../Component/Footer';   
const VirtualTour = () => {  
    const showImage = (id) => {
        // Hide all panoramas
        document.querySelectorAll(".panorama").forEach((el) => {
          el.classList.remove("active");
        });
    
        // Show the selected panorama
        document.getElementById(id).classList.add("active");
      };
  useEffect(() => {
    document.title = 'Virtual Tour - St. Francis Xavier School';  
}, []); 
    return (
        <>
        <Header/>
            <div className="innerslide">
                <ul className="breadcrumb">
                    <li><Link to="/"> Home</Link> </li>  
                    <li>School</li>
                    <li>Virtual Tour</li>
                </ul>
            </div> 
            <section className="innerbody">
            <div className="container"> 
            <div className="row">
            <div className="col-lg-3 virtual_tour_scroll">
                <ul>
                <Link to="" onClick={() => showImage("mainground")}>
                <li>Main Ground</li>
             </Link>
              <Link to="" onClick={() => showImage("assembly_hall")}>
                <li>Assembly Ground</li>
             </Link>
              <Link to="" onClick={() => showImage("ground")}>
                <li>Ground</li>
             </Link>
              <Link to="" onClick={() => showImage("school_area")}>
                <li>School Centre Area</li>
             </Link>
              <Link to="" onClick={() => showImage("basketball")}>
                <li>Basketball Court</li>
             </Link>
              <Link to="" onClick={() => showImage("chemistry_lab")}>
                <li>Chemistry Lab</li>
             </Link>
              <Link to="" onClick={() => showImage("computer")}>
                <li>Computer Lab</li>
             </Link>
              <Link to="" onClick={() => showImage("kids_coridor")}>
                <li>Kids Corridor</li>
             </Link>
              <Link to="" onClick={() => showImage("music")}>
                <li>Music Room</li>
             </Link>
                </ul>
            </div>

            <div className="col-lg-9" id="theDiv" style={{position:"relative",overflow:"hidden"}}>
            <div className="panorama active" id="mainground">
            
              <img
                src="https://webapi.entab.info/api/image/SFXH/public/images/Virtual_Tour/mainground.jpg"
                alt="Main Ground"
              />
            
          </div>
          <div className="panorama" id="assembly_hall">
            
              <img
                src="https://webapi.entab.info/api/image/SFXH/public/images/Virtual_Tour/assembly_hall.jpg"
                alt="Assembly Ground"
              />
            
          </div>
          <div className="panorama" id="ground">
            
              <img
                src="https://webapi.entab.info/api/image/SFXH/public/images/Virtual_Tour/ground.jpg"
                alt="Ground"
              />
            
          </div>
          <div className="panorama" id="school_area">
            
              <img
                src="https://webapi.entab.info/api/image/SFXH/public/images/Virtual_Tour/school_area.jpg"
                alt="School Centre Area"
              />
            
          </div>
          <div className="panorama" id="basketball">
            
              <img
                src="https://webapi.entab.info/api/image/SFXH/public/images/Virtual_Tour/basketball.jpg"
                alt="Basketball Court"
              />
            
          </div>
          <div className="panorama" id="chemistry_lab">
            
              <img
                src="https://webapi.entab.info/api/image/SFXH/public/images/Virtual_Tour/chemistry_lab.jpg"
                alt="Chemistry Lab"
              />
            
          </div>
          <div className="panorama" id="computer">
            
              <img
                src="https://webapi.entab.info/api/image/SFXH/public/images/Virtual_Tour/computer.jpg"
                alt="Computer Lab"
              />
            
          </div>
          <div className="panorama" id="kids_coridor">
            
              <img
                src="https://webapi.entab.info/api/image/SFXH/public/images/Virtual_Tour/kids_coridor.jpg"
                alt="Kids Corridor"
              />
            
          </div>
          <div className="panorama" id="music">
            
              <img
                src="https://webapi.entab.info/api/image/SFXH/public/images/Virtual_Tour/music.jpg"
                alt="Music Room"
              />
            
          </div>
            </div>
        </div>
                </div>
           </section>
           <Footer/>
        </>
    );
}

export default VirtualTour;
